import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutStatusErrorQuickInfo extends Layout {
    labelErrorDescriptionTitle: Label;
    labelStatusDescription: Label;
    labelTemplateErrorTxt: Label;
    panelMain: Panel;
    sourceEdiMapError: DataSource;
    tableErrors: Table;
}
